module.exports = __webpack_public_path__ + "static/media/063-girl-7.6f74e97c.svg";